enum OcrState {
  NONE = 'NONE',
  AVTALEGIRO = 'AVTALEGIRO',
  AVTALEGIROTEST = 'AVTALEGIROTEST',
}

export default OcrState;
